import React, { useState } from 'react'
import countryTelephoneData from 'country-telephone-data'
import clsx from 'clsx'
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  InputLabel,
  Link,
  TextField,
  Typography,
} from '@mui/material'

import GooglePlacesAutocomplete from '../../../../../context/ShippingSend/Step1Origin/NewAddress/GooglePlacesAutocomplete'
import { useDestinationCountries } from '../../../../../services/destinationCountries'
import Autocomplete from '../../../../../ui/components/autocomplete'
import useTranslations from '../../../../../i18n/useTranslations'
import Tabs from '../../../../../ui/components/tabs'

import Map from './Map'
import List from './List'
import PickupPointSelected from './PickupPointSelected'

import styles from './styles'
import './PickupPoint.styles.css'
import StyledPaper from '../../../../components/StyledPaper'

export const OPTIONS = {
  map: 'map',
  list: 'list',
}

const PickupPoint = ({
  countryRestrictions,
  changeAddress,
  selectAddress,
  deliveryPoints,
  selectedAddress,
  searchedAddress,
  confirmAddress,
  confirmedAddress,
  onChange,
  onBlur,
  values,
  fieldErrors,
}) => {
  const formatMessage = useTranslations()
  const [value, setValue] = useState(OPTIONS.map)
  const [searchError] = useState(false)
  const [continueWithoutConfirm] = useState(false)
  const [mapPointSelect] = useState(true)

  const { data: countries } = useDestinationCountries()

  const countryPhones = countryTelephoneData.allCountries
    .sort((a, b) => {
      if (a.iso2 === 'es') return -1
      if (b.iso2 === 'es') return 1
      if (a.iso2 === 'pt') return -1
      if (b.iso2 === 'pt') return 1
      return a.name.localeCompare(b.name);
    })
    .map((country, index, arr) => {
      if (
        index === arr.length - 1 ||
        country.dialCode !== arr[index + 1].dialCode
      ) {
        let countryName = countries.find(
          ({ code }) => code === country.iso2.toLocaleUpperCase(),
        )
        if (countryName)
          return {
            dialCode: `+${country.dialCode}`,
            countryCode: country.iso2,
            name: countryName ? countryName?.label : country?.name,
          }
        if (country.dialCode === '1')
          return {
            dialCode: `+${country.dialCode}`,
            countryCode: 'us',
            name: countryName
              ? countryName?.label
              : 'Estados Unidos de América',
          }
      }
      return null
    })
    .filter(country => country !== null)

  const deselectAddress = () => {
    selectAddress(undefined)
  }

  const getZoomCenter = markers => {
    if (markers.length === 0) {
      return
    }

    var minLat = markers[0].lat
    var maxLat = markers[0].lat
    var minLng = markers[0].lng
    var maxLng = markers[0].lng

    for (var i = 1; i < markers.length; i++) {
      var lat = markers[i].lat
      var lng = markers[i].lng

      if (lat < minLat) minLat = lat
      if (lat > maxLat) maxLat = lat
      if (lng < minLng) minLng = lng
      if (lng > maxLng) maxLng = lng
    }

    var centerLat = (minLat + maxLat) / 2
    var centerLng = (minLng + maxLng) / 2

    var deltaLat = maxLat - minLat
    var deltaLng = maxLng - minLng

    var fit = 3
    var zoomLat = Math.floor(
      Math.log2((180 * window.innerHeight) / (fit * deltaLat * 256)),
    )
    var zoomLng = Math.floor(
      Math.log2((360 * window.innerWidth) / (fit * deltaLng * 256)),
    )
    var zoom = Math.min(zoomLat, zoomLng)
    if (zoom === Infinity) zoom = 8

    return {
      center: { lat: centerLat, lng: centerLng },
      zoom: zoom,
    }
  }

  const MOCK_TABS = [
    {
      value: OPTIONS.map,
      label: 'Mapa',
      content: (
        <div style={{ position: 'relative' }}>
          <Map
            addresses={deliveryPoints}
            confirmPlace={place => {}}
            selectedAddress={selectedAddress}
            selectAddress={selectAddress}
            selectedPlace={selectedAddress}
            deselectAddress={deselectAddress}
            center={
              searchedAddress === undefined
                ? undefined
                : getZoomCenter(deliveryPoints)?.center
            }
            zoom={
              searchedAddress === undefined
                ? undefined
                : getZoomCenter(deliveryPoints)?.zoom
            }
          />
        </div>
      ),
    },
    {
      value: OPTIONS.list,
      label: 'Lista',
      content: (
        <List
          deliveryPoints={deliveryPoints}
          selectAddress={selectAddress}
          selectedAddress={selectedAddress}
        />
      ),
    },
  ]
  return (
    <Box sx={styles.wrapper}>
      {!confirmedAddress ? (
        <>
          <GooglePlacesAutocomplete
            sx={styles.searchField}
            changeAddress={changeAddress}
            countries={countryRestrictions}
            placeholder={formatMessage(
              'message:search-by-street-zone-or-postal-code',
            )}
          />
          {searchedAddress !== undefined &&
          searchedAddress !== null &&
          !Boolean(searchedAddress?.postalCode) ? (
            <Alert severity="error" sx={styles.searchErrorAlert}>
              <AlertTitle>
                <strong>{formatMessage('noun:delivery-point:error')}</strong>
              </AlertTitle>
              <Typography variant="body2">
                {formatMessage(
                  'error:form:search-not-possible-verify-postal-code',
                )}
              </Typography>
            </Alert>
          ) : null}
          {searchError ? (
            <Alert severity="error" sx={styles.searchErrorAlert}>
              <Typography variant="body2">
                {formatMessage('error:form:search-not-possible')}
              </Typography>
            </Alert>
          ) : null}
          <Tabs
            tabs={MOCK_TABS}
            value={value}
            onTabChange={setValue}
            sx={styles.tabs}
          />
        </>
      ) : (
        <PickupPointSelected pickupPoint={selectedAddress} />
      )}

      {continueWithoutConfirm ? (
        <Alert severity="warning" sx={styles.warningAlert}>
          <Typography variant="body2">
            {formatMessage('message:click-on-confirm-to-continue')}
          </Typography>
        </Alert>
      ) : null}

      {mapPointSelect && !confirmedAddress ? (
        <Button
          disabled={selectedAddress === undefined}
          variant="contained"
          size="smaller"
          sx={styles.confirmButton}
          // onClick={() => setConfirmMapPointSelect(true)}
          onClick={() => {
            confirmAddress(selectedAddress)
          }}
        >
          {formatMessage('action:confirm')}
        </Button>
      ) : mapPointSelect && confirmedAddress ? (
        <>
          <Link
            onClick={() => {
              confirmAddress(undefined)
            }}
            sx={styles.changePickupPoint}
          >
            {formatMessage('action:change-delivery-point')}
          </Link>
          <Box component="section" sx={styles.section}>
            <Typography
              variant="h2"
              className={clsx('secondaryTitle', 'decorator')}
              sx={styles.title}
            >
              {formatMessage('noun:recipient-date')}
            </Typography>
            <Box sx={styles.fieldsWrapper}>
              <TextField
                name="address.name"
                error={fieldErrors?.address?.name}
                helperText={
                  fieldErrors?.address?.name && fieldErrors?.address?.name?.key
                    ? formatMessage(fieldErrors?.address?.name?.key)
                    : null
                }
                label={formatMessage('user-zone:contact-person')}
                value={values.address.name}
                onBlur={onBlur}
                onChange={onChange}
                InputLabelProps={{ required: true }}
              />

              <Box sx={styles.fieldMD}>
                <InputLabel required={true}>
                  {formatMessage('noun:mobile-phone')}
                </InputLabel>
                <Box sx={styles.fieldPrefixPhone}>
                  <Autocomplete
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue?.length) return options
                      return options.filter(option =>
                        `${option?.dialCode} | ${option?.name}`
                          .toLowerCase()
                          .includes(inputValue.toLowerCase()),
                      )
                    }}
                    noSearchIcon
                    options={countryPhones ?? []}
                    value={values?.address.phonePrefix}
                    isOptionEqualToValue={(option, value) =>
                      option?.dialCode === value
                    }
                    disableClearable
                    PaperComponent={props => <StyledPaper {...props} />}
                    name="address.phonePrefix"
                    onChange={(_, phonePrefix) => {
                      if (phonePrefix === null) {
                        onChange({
                          target: {
                            name: 'address.phonePrefix',
                            value: '+34',
                          },
                        })
                        return
                      }
                      onChange({
                        target: {
                          name: 'address.phonePrefix',
                          value: phonePrefix?.dialCode ?? phonePrefix,
                        },
                      })
                    }}
                    getOptionLabel={option => {
                      let findCountry = countryPhones.find(
                        ({ dialCode }) => dialCode === option,
                      )
                      if (option?.dialCode) return option?.dialCode
                      return `${findCountry?.dialCode}`
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        {...props}
                        style={{ height: '100%', width: '100%', padding: 15 }}
                        key={`${option?.dialCode} | ${option?.name}`}
                      >
                        {`${option?.dialCode} | ${option?.name}`}
                      </Box>
                    )}
                    sx={styles.fieldPrefixPhoneSelect}
                    inputProps={{
                      placeholder: formatMessage('noun:phonePrefix'),
                    }}
                    onBlur={onBlur}
                  />
                  <TextField
                    name="address.phone"
                    error={fieldErrors?.address?.phone}
                    helperText={
                      fieldErrors?.address?.phone &&
                      fieldErrors?.address?.phone?.key
                        ? formatMessage(fieldErrors?.address?.phone?.key)
                        : null
                    }
                    value={values.address.phone}
                    onBlur={onBlur}
                    onChange={onChange}
                    InputLabelProps={{ required: true }}
                  />
                </Box>
              </Box>

              <TextField
                name="address.email"
                error={fieldErrors?.address?.email}
                helperText={
                  fieldErrors?.address?.email &&
                  fieldErrors?.address?.email?.key
                    ? formatMessage(fieldErrors?.address?.email?.key)
                    : null
                }
                label={formatMessage('noun:email')}
                value={values.address.email}
                onChange={onChange}
                onBlur={onBlur}
                InputLabelProps={{ required: true }}
              />
            </Box>
            <Alert severity="info" sx={styles.pickupPointAlert}>
              <Typography variant="body2">
                {formatMessage('message:pickup-point-contact-data')}
              </Typography>
            </Alert>
          </Box>
        </>
      ) : null}
    </Box>
  )
}

export default PickupPoint
